import React, { useRef, useEffect } from 'react';
import { TextField } from '@mui/material';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

export default function AddressAutocomplete({ 
    onPlaceSelected, 
    placeholder = "🔍 Busca tu urbanización, calle o lugar conocido..." 
}) {
    const inputRef = useRef(null);
    const places = useMapsLibrary('places');

    useEffect(() => {
        if (!places || !inputRef.current) return;
        
        const autocomplete = new places.Autocomplete(inputRef.current, {
            fields: ['geometry', 'name', 'formatted_address'],
            // Si quieres limitar las búsquedas a un país específico, descomenta esto:
            // componentRestrictions: { country: 've' } 
        });

        const listener = autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            onPlaceSelected(place);
        });

        // Limpieza: Removemos el listener cuando el componente se destruye
        return () => {
            if (listener) {
                listener.remove();
            }
        };
    }, [places, onPlaceSelected]);

    return (
        <TextField 
            inputRef={inputRef}
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            sx={{ 
                mb: 2, 
                bgcolor: '#f8f9fa', 
                '& .MuiOutlinedInput-root': { borderRadius: 3, fontWeight: '500' } 
            }}
        />
    );
}